export default __webpack_public_path__ + "static/media/bernay10.69ae12ac.jpg";